export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_13.4387d2d6.jpg";